export default "__VITE_ASSET__Dc84$JhY__"